import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { MyCreditPurchasesView } from "./MyCreditPurchasesView";
import { CreditPurchaseViewStore } from "../../store/CreditPurchaseViewStore";
import { useStore } from "../../../../hooks";
import { myCreditPurchasesService } from "../../services/myCreditPurchasesService";

export const MyCreditPurchasesViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/my-credit-purchases/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new CreditPurchaseViewStore(rootStore);
      // Proyección: cargar por el documento de la proyección (solo sus campos)
      // en vez del de la entidad — que puede pedir refs que este rol no puede
      // leer (p.ej. CreditPurchase.tenant para un SiteAdmin). Solo se overridea
      // getOne: es lo único que usa el view y sus tipos coinciden.
      s.service = { ...s.service, getOne: myCreditPurchasesService.getOne };
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [
            {
              id: "compra",
              label: rootStore.langStore.groupMyCreditPurchasesCompraLabel,
            },
          ],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <MyCreditPurchasesView creditPurchaseViewStore={store} />
      </PageLayout>
    </div>
  );
});
